import { IImageMedia } from '~/lib/data-contract';
import { ImageMedia } from '~/shared/components/ImageMedia/ImageMedia';
import { useFrame } from '~/shared/utils/frame/hooks/useFrame';

import { noImage } from '../../../../utils/noImage';

export const imageSizes = '180px'; // The difference between resolutions is small enough that a single size is enough

export type ProductPickerImageProps = {
	image?: IImageMedia;
	caption?: string;
};

export const ProductPickerImage = ({ image }: ProductPickerImageProps) => {
	const frame = useFrame();
	const imageOrFallback = image || frame.data.vertical?.defaultProductImage || noImage;
	return (
		<ImageMedia
			sizes={imageSizes}
			image={imageOrFallback}
			fill
			objectFit="contain"
		/>
	);
};
